import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../../CacheDataRoute';
import BarMenuPublicCategory from '@routes/BarMenu/stages/BarMenuPublicCategory';

export const Route = createFileRoute('/barmenu/$barId/$categoryType')({
  staticData: {
    layout: {
      path: '/barmenu/:barId/:categoryType',
      withoutHeader: true,
      withoutFooter: true
    }
  },
  component: () => (
    <CacheDataRoute
      component={BarMenuPublicCategory}
      path='/barmenu/:barId/:categoryType'
    />
  )
});
